// v2/components/Announcements.js — ana sayfa duyuru karti (yalnizca gorsel banner)
// Veri: /api/v2/announcements/  |  Yonetim: /v2/admin/announcements
// Site ici link (/...) ayni sekmede, dis link (https://...) yeni sekmede acilir.
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import layout from '../styles/HomeLayout.module.css';
import styles from './Announcements.module.css';

const LOGO = '/asotomotivlogo.png';

function icLink(href) {
  return typeof href === 'string' && href.startsWith('/') && !href.startsWith('//');
}

function Banner({ a, onError }) {
  const img = (
    <img className={styles.hero} src={a.image} alt={a.title || 'Duyuru'}
         onError={onError} draggable={false} />
  );
  if (!a.href) return img;
  if (icLink(a.href)) {
    return <Link className={styles.heroLink} to={a.href} title={a.title || undefined}>{img}</Link>;
  }
  return (
    <a className={styles.heroLink} href={a.href} target="_blank"
       rel="noopener noreferrer" title={a.title || undefined}>{img}</a>
  );
}

export default function Announcements({ items = [], loading = false, interval = 7000 }) {
  const [idx, setIdx] = useState(0);
  const [failed, setFailed] = useState({});
  const [durdu, setDurdu] = useState(false);

  // gorseli olmayan ya da yuklenemeyen banner listeden duser
  const liste = useMemo(
    () => items.filter((it) => it && it.image && !failed[it.id]),
    [items, failed],
  );
  const total = liste.length;

  const go = useCallback((d) => {
    if (total) setIdx((i) => (i + d + total) % total);
  }, [total]);

  // otomatik gecis: fare/klavye odagi karttayken ve hareket azaltma aciksa durur
  useEffect(() => {
    if (total < 2 || durdu) return undefined;
    const azalt = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (azalt) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % total), interval);
    return () => clearInterval(t);
  }, [total, interval, durdu]);

  // liste kisalirsa index disarda kalmasin
  useEffect(() => { setIdx((i) => (i >= total ? 0 : i)); }, [total]);

  // siradaki gorseli onden yukle (geciste bos kare kalmasin)
  useEffect(() => {
    if (total < 2) return;
    const sonraki = liste[(idx + 1) % total];
    if (sonraki) { const im = new Image(); im.src = sonraki.image; }
  }, [idx, total, liste]);

  const a = total ? liste[Math.min(idx, total - 1)] : null;

  let govde;
  if (loading && !total) {
    govde = (
      <div className={`${styles.body} ${styles.bodyImage}`}>
        <div className={styles.skel} aria-hidden="true" />
      </div>
    );
  } else if (!a) {
    govde = (
      <div className={`${styles.body} ${styles.emptyBody}`}>
        <img className={styles.emptyLogo} src={LOGO} alt="" />
        <span className={styles.emptyText}>Şu an yayında duyuru bulunmuyor</span>
      </div>
    );
  } else {
    govde = (
      <div className={`${styles.body} ${styles.bodyImage}`}>
        <div className={styles.heroWrap} key={a.id}>
          <Banner a={a} onError={() => setFailed((f) => ({ ...f, [a.id]: true }))} />
        </div>
        {total > 1 && (
          <div className={`${styles.foot} ${styles.footOnImage}`}>
            <span className={styles.dots}>
              {liste.map((it, i) => (
                <button
                  key={it.id} type="button"
                  className={`${styles.dot} ${i === idx ? styles.dotOn : ''}`}
                  onClick={() => setIdx(i)}
                  aria-label={`${i + 1}. duyuru`}
                  aria-current={i === idx ? 'true' : undefined}
                />
              ))}
            </span>
            <span className={styles.navs}>
              <button type="button" className={styles.nav} onClick={() => go(-1)} aria-label="Önceki duyuru">
                <ChevronLeft size={14} />
              </button>
              <button type="button" className={styles.nav} onClick={() => go(1)} aria-label="Sonraki duyuru">
                <ChevronRight size={14} />
              </button>
            </span>
          </div>
        )}
      </div>
    );
  }

  return (
    <section
      className={`${layout.panel} ${layout.fixedNotice}`}
      aria-label="Duyurular"
      onMouseEnter={() => setDurdu(true)}
      onMouseLeave={() => setDurdu(false)}
      onFocusCapture={() => setDurdu(true)}
      onBlurCapture={() => setDurdu(false)}
    >
      <div className={layout.panelHead}>
        <span className={layout.bar} />
        <h2 className={layout.panelTitle}>Duyurular</h2>
        <span className={layout.headSpacer} />
        {total > 1 && <span className={styles.counter}>{idx + 1} / {total}</span>}
      </div>
      {govde}
    </section>
  );
}
